import useStore from "@/store"
import { Navigate, Outlet } from "react-router"

export default function ProtectedRoute() {
  const store = useStore((state) => state.user)

  if (!store.token) {
    return <Navigate to="/login" />
  }

  return <Outlet />
}
